import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, Modal, Spin, message } from 'antd';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { addSVG, deleteSVG, editSVG } from '../../assets/settings/SVGs';
import ModalAddNewPaymentWay from '../../components/settings/modal/ModalAddNewPaymentWay';
import { deletePayments, getPayments } from '../../network/settings';
import queryClient from '../../services/react-query/queryClient';
type Props = {};

const PaymentTypes = (props: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const showModal = (data?: any) => {
    setIsModalOpen(true);
    setData(data);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setData(false);
  };
  const showConfirmModal = () => {
    setIsConfirmModalOpen(true);
  };

  const closeModal = () => {
    setIsConfirmModalOpen(false);
  };
  const intl = useIntl();
  const { locale } = useIntl();
  console.log(data);

  const { data: payments, isLoading } = useQuery(['payment'], () =>
    getPayments()
  );
  const { mutate: DeletePayment } = useMutation(deletePayments, {
    onSuccess: (res: any) => {
      if (
        res?.response?.status === 422 ||
        res?.response?.status === 500 ||
        res?.response?.status === 404
      ) {
        message.error(res?.response?.data?.message);
      } else {
        message.success('payment Deleted');
        queryClient.invalidateQueries(['payment']);
      }
    },
  });
  return (
    <>
      {/* <Modal
        width="30%"
        open={isConfirmModalOpen}
        centered
        onCancel={closeModal}
        className="max-md:min-w-[95%] max-lg:min-w-[80%]"
        footer={null}
        destroyOnClose
      >
        <ConfirmModal
          title={"Confirm Deletion"}
          para={"Are you sure you want to delete this payment way?"}
          status={"delete"}
          closeModal={closeModal}
          color={"#C43535"}
          request={del}
        />
      </Modal> */}
      <Modal
        width={'50%'}
        open={isModalOpen}
        onCancel={handleCancel}
        className="max-md:!w-[95%] max-xl:!w-[75%]"
        footer={null}
        destroyOnClose
      >
        <ModalAddNewPaymentWay
          setData={setData}
          data={data}
          close={handleCancel}
        />
      </Modal>
      <div>
        <div className="flex items-center gap-2 text-2xl font-semibold leading-7 text-color-primary text-end">
          <span className="">
            {intl.formatMessage({ id: 'paymentMethodsTitle' })}
          </span>
        </div>
        <div className="my-4 text-base font-normal leading-7 text-color-gray ">
          {intl.formatMessage({ id: 'paymentMethodsDescription' })}
        </div>
        <Spin spinning={isLoading}>
          <div className="bg-[#EEF0FF] px-4 py-6 rounded-lg">
            <div className="w-full p-4 bg-white rounded-lg">
              <span className="w-full mb-4 text-sm text-color-primary">
                {intl.formatMessage({ id: 'availableMethods' })}:
              </span>
              <div className="flex items-center justify-between max-lg:gap-2 max-lg:w-full">
                <div className="flex items-center justify-start gap-4 my-4 mb-2 max-lg:flex-col max-lg:w-full">
                  {payments?.data?.map((e: any) => (
                    <div className="flex w-full items-center max-lg:justify-self-start gap-6 max-lg:gap-3 max-lg:px-3 max-lg:py-2 px-4 py-3 border-color-primary border-solid border-[1px] rounded-lg bg-[#FBFBFF]">
                      <span className="whitespace-nowrap">
                        {e.name[locale]}
                      </span>
                      <div className="flex items-center gap-2">
                        {e?.editable ? (
                          <>
                            <span
                              onClick={() => showModal(e)}
                              className="flex items-center cursor-pointer "
                            >
                              {editSVG}
                            </span>
                            <span
                              onClick={() => DeletePayment(e.id)}
                              className="flex items-center cursor-pointer "
                            >
                              {deleteSVG}
                            </span>
                          </>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
                <Button
                  type="primary"
                  className="flex items-center gap-2 lg:my-auto max-lg:self-start max-lg:mt-[15px]"
                  onClick={() => showModal()}
                >
                  {addSVG} {intl.formatMessage({ id: 'addNew' })}
                </Button>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </>
  );
};

export default PaymentTypes;
